module.exports = __webpack_public_path__ + "static/media/ic-checked-out.ba4c56bf.svg";